module.exports = "https://static.wmbcdn.com/uniweb/images/0dc199fb279cc5c1b919d4eb4dfe1363.svg";